import React from "react";

export default function WebsiteSetupMessage(props) {
  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "auto",
        padding: "25px",
        borderRadius: "16px",
        background: "#ffffff",
        boxShadow: "0 4px 18px rgba(0,0,0,0.07)",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      {/* Image Banner */}
      <img
        src="https://cdn-icons-png.flaticon.com/512/9068/9068779.png"
        alt="Website Setup Illustration"
        style={{
          width: "120px",
          display: "block",
          margin: "0 auto 20px auto",
        }}
      />

      <h2
        style={{
          textAlign: "center",
          color: "#1E3A8A",
          marginBottom: "15px",
        }}
      >
        Setup of your website - <strong>{props.domainName}</strong> is in progress.
      </h2>

      <p style={{ fontSize: "16px", color: "#374151" }}>
        Thank you for sharing your preferred website domain and providing your
        initial content. We have now begun the booking process and are preparing
        your website for launch.
      </p>

      <p style={{ fontSize: "16px", color: "#374151" }}>
        You may continue to share or update any website content you would like
        us to include. Our team will keep you informed throughout each step of
        the setup process.
      </p>

      <p style={{ fontSize: "16px", color: "#374151" }}>
        Meanwhile, we are configuring your domain and hosting environment to
        ensure your website goes live smoothly and as soon as possible.
      </p>

      {/* Info Box */}
      <div
        style={{
          marginTop: "20px",
          padding: "18px",
          background: "#F0F7FF",
          borderLeft: "5px solid #1D4ED8",
          borderRadius: "10px",
        }}
      >
        <h3 style={{ margin: "0 0 8px 0", color: "#1D4ED8" }}>
          Need Assistance?
        </h3>
        <p style={{ margin: 0, color: "#1E3A8A" }}>
          If you have any questions or need further support, please create a
          communication ticket — our team will be happy to help.
        </p>
      </div>
    </div>
  );
}
